import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError, tap } from 'rxjs';

/** Utils */
import { AuthUtils } from './auth.utils';

/** Envoriment */
import { environment } from 'environments/environment';

/** Service */
import { UserService } from '../user/user.service';

/** Interface */
import { ResponseRest } from 'app/interface/response-rest';
import { Authorization } from 'app/module-auth/domain/auth/auth';

@Injectable({ providedIn: 'root' })
export class AuthService {

    private _userService = inject(UserService);

    /** Propiedad configuración */
    private configSession: string = 'SOFAPP';

    /**propiedad url */
    private url: string = environment.urlAuth + "/auth";

    /** Popiedad autenticación */
    private _authenticated: boolean = false;

    /** Servicio */
    private _httpClient = inject(HttpClient);


    set session(auth: Authorization) {
        localStorage.setItem(this.configSession, JSON.stringify(auth));
    }

    set application(application: string) {
        const session: Authorization = JSON.parse(localStorage.getItem(this.configSession));
        session.Application = application;
        localStorage.setItem(this.configSession, JSON.stringify(session));
    }

    get session(): Authorization {
        if (localStorage.getItem(this.configSession) === 'undefined') {
            this.signOut();
        }
        const session: Authorization = JSON.parse(localStorage.getItem(this.configSession));
        return session;
    }

    /**@param credentials*/
    signIn(credentials: { User: string; Password: string, Group: string }): Observable<any> {

        let url = `${this.url}/SignIn`;

        return this._httpClient
            .post(url, credentials)
            .pipe(
                switchMap((response: ResponseRest) => {
                    if (response.Message.Flag) {
                        this.session = response.Data;
                        this._authenticated = true;
                        this._userService.user = response.Data.User;
                    }
                    return of(response);
                }),
            );
    }

    signInUsingToken(): Observable<any> {

        let url = `${this.url}/SignInWithToken`;

        return this._httpClient
            .post(url, {
                Token: this.session.Token,
            }).pipe(
                catchError(() =>
                    of(false),
                ),
                switchMap((response: any) => {

                    if (response.Message.Flag) {
                        this.session = response.Data;
                    }
                    this._authenticated = true;
                    this._userService.user = response.Data.User;
                    return of(true);
                }),
            );
    }

    /*** Sign out */
    signOut(): Observable<any> {
        localStorage.removeItem(this.configSession);
        this._authenticated = false;
        return of(true);
    }


    /**Check the authentication status*/
    check(): Observable<boolean> {


        // Check if the user is logged in
        if (this._authenticated) {
            return of(true);
        }

        // Check the access token availability
        if (!this.session) {
            return of(false);
        }

        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.session.Token)) {
            return of(false);
        }

        return this.signInUsingToken();
    }


    /** Refresca token */
    refreshToken(): Observable<any> {
        const body = JSON.stringify(this.session);
        const url = `${this.url}RefreshToken`;
        return this._httpClient
            .post(url, body).pipe(
                tap((response: any) => {
                    this.session = response.Data;
                    this._authenticated = true;
                })
            );
    }


}
